import Vue from 'vue';

/**
 * Allows us to track whether or not different datasets have loaded,
 * as we don't want certain things to be accessible in the app if the data for it hasn't loaded yet
 * This functionality will be replicated in a lot of places,
 * so this is a generic util class that can be used in any module
 */
export class LoadingUtil {
  /**
   * Vuex state to mixin with a store which needs loading state
   *
   * @param {string} [defaults]
   * @return {Object}
   */
  static state(...defaults) {
    const loaded = {};
    for (const d of defaults) {
      loaded[d] = false;
    }
    return {
      loaded
    };
  }

  /**
   * Vuex getters to mixin with a store which has loading state
   *
   * @param {Logger} log
   * @return {Object}
   */
  static getters(log) {
    return {
      loaded(state) {
        const loading = Object.entries(state.loaded)
            .filter(([, loaded]) => !loaded)
            .map(([name]) => name);
        if (loading.length > 0) {
          log.debug(loading + ' not loaded');
          return false;
        } else {
          return true;
        }
      }
    };
  }

  /**
   * Vuex mutations to mixin with a store which has loading state
   *
   * @return {Object}
   */
  static mutations() {
    return {
      loading(state, name) {
        Vue.set(state.loaded, name, false);
      },
      loaded(state, name) {
        Vue.set(state.loaded, name, true);
      },
      setLoaded(state, loaded) {
        state.loaded = loaded;
      },
      removeLoaded(state, name) {
        Vue.delete(state.loaded, name);
      }
    };
  }
}
